export const GTM_START = 'gtm.start';
export const GTM_START_EVENT = 'gtm.js';
